// components/TanksPaper.jsx

import { Paper, Typography } from '@mui/material';
import React from 'react';

import { FUEL_TANK_SKIP_INDICES } from '../TabPanelCondition.constants';
import { getSensorCountText } from '../TabPanelCondition.utils';
import { CraneAngleSection } from './CraneAngleSection';
import { FuelTankIndicator } from './FuelTankIndicator';
import { TankSection } from './TankSection';

/**
 * Компонент для отображения секции с танками или углом крана
 */
export const TanksPaper = ({
  transportItem,
  conditionItem,
  galileoskyDevice,
  isFuelTank,
  isCrane,
  guardData,
  guardDisabled,
  declOfNum,
  onGuardClick,
  config,
}) => {
  // Определяем список танков
  const tanks = transportItem.tank.length ? transportItem.tank : config.numberOfTank.slice(0, -1);

  // Получаем текст о количестве датчиков
  const sensorCountText = getSensorCountText(galileoskyDevice, conditionItem.data.sensor_count, declOfNum, config);

  return (
    <Paper variant='outlined'>
      {/* Заголовок */}
      <Typography className='MuiPaper-label' variant='body1'>
        {isCrane ? 'Угол стрелы крана' : 'Топливо в секциях'}
      </Typography>

      {/* Подзаголовок с количеством датчиков */}
      <Typography className='MuiPaper-sublabel' variant='body1'>
        {sensorCountText}
      </Typography>

      {/* Для крана показываем угол стрелы */}
      {isCrane && <CraneAngleSection angle={conditionItem.data.dun1} />}

      {/* Для не-кранов показываем секции танков */}
      {!isCrane &&
        tanks.map((_, index) => {
          // Для топливозаправщика пропускаем определенные индексы
          if (isFuelTank && FUEL_TANK_SKIP_INDICES.includes(index)) {
            return null;
          }

          return (
            <TankSection
              key={index}
              index={index}
              dunValue={conditionItem.data[`dun${index + 1}`]}
              dutValue={conditionItem.data[`dut${index + 1}`]}
              dpsValue={conditionItem.data[`dps_${index + 1}`]}
              dntValue={conditionItem.data[`dnt${index + 1}`]}
              guardOutBit={guardData.guardOutTank[index]}
              guardOutAll={guardData.guardOut}
              guardDisabled={guardDisabled}
              galileoskyDevice={galileoskyDevice}
              transportItem={transportItem}
              conditionItem={conditionItem}
              guardStatusTank={guardData.guardStatusTank}
              isFuelTank={isFuelTank}
              onGuardClick={onGuardClick}
              config={config}
            />
          );
        })}

      {/* Для топливозаправщика показываем индикатор заправочного пистолета */}
      {isFuelTank && (
        <FuelTankIndicator in5Value={conditionItem.data.in5} galileoskyDevice={galileoskyDevice} conditionItem={conditionItem} />
      )}
    </Paper>
  );
};
